import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import API from '../util/API';


export const fetchShippingAddresses = createAsyncThunk(
  'shippingAddresses/fetchAll',
  async (_, {rejectWithValue}) => {
    try {
      const res = await API.get('/shipping-address');
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch shipping addresses');
    }
  }
);

export const addShippingAddress = createAsyncThunk(
  'shippingAddresses/add',
  async (addressData, {rejectWithValue}) => {
    try {
      const res = await API.post('/shipping-address', addressData);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to add shipping address');
    }
  }
);

export const updateShippingAddress = createAsyncThunk(
  'shippingAddresses/update',
  async ({ id, addressData }, { rejectWithValue }) => {
    try {
      const res = await API.put(`/shipping-address/${id}`, addressData);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to update shipping address');
    }
  }
);

export const deleteShippingAddress = createAsyncThunk(
  'shippingAddresses/delete',
  async (id, { rejectWithValue }) => {
    try {
      await API.delete(`/shipping-address/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to delete shipping address');
    }
  }
);

export const setDefaultShippingAddress = createAsyncThunk(
  'shippingAddresses/setDefault',
  async (id, { rejectWithValue }) => {
    try {
      const res = await API.patch(`/shipping-address/default/${id}`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to set default address');
    }
  }
);

export const shippingAddressSlice = createSlice({
  name: 'shippingAddresses',
  initialState: {
    shippingAddresses: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShippingAddresses.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchShippingAddresses.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.shippingAddresses = action.payload;
      })
      .addCase(fetchShippingAddresses.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(addShippingAddress.fulfilled, (state, action) => {
        state.shippingAddresses.push(action.payload);
      });

    builder
      .addCase(updateShippingAddress.fulfilled, (state, action) => {
        const updated = action.payload;
        state.shippingAddresses = state.shippingAddresses.map((a) =>
          a._id === updated._id ? updated : a
        );
      })
      .addCase(deleteShippingAddress.fulfilled, (state, action) => {
        const id = action.payload;
        state.shippingAddresses = state.shippingAddresses.filter((a) => a._id !== id);
      })
      .addCase(setDefaultShippingAddress.fulfilled, (state, action) => {
        const defaultAddr = action.payload;
        state.shippingAddresses = state.shippingAddresses.map((a) => {
          if (a._id === defaultAddr._id) return { ...a, ...defaultAddr, isDefault: true };
          return { ...a, isDefault: false };
        });
      });

    builder
      .addMatcher(
        (action) => action.type.startsWith('shippingAddresses/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.error = action.payload;
        }
      );
  } 
});

export default shippingAddressSlice.reducer;